import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Admin.css";
import AdminTeam from "./AdminTeam";
import AdminUserSearch from "./AdminUserSearch";
import AdminUserManage from "./AdminUserManage";

function Admin() {
  const location = useLocation();
  const navigate = useNavigate();
  const [authState, setAuthState] = useState("checking");
  const [adminName, setAdminName] = useState("");
  const [signingOut, setSigningOut] = useState(false);

  useEffect(() => {
    let active = true;
    fetch("/api/admin/session", { credentials: "include" })
      .then((response) => {
        if (response.status === 401) {
          navigate("/admin/login", { replace: true });
          return null;
        }
        if (!response.ok) throw new Error("Admin session check failed.");
        return response.json();
      })
      .then((data) => {
        if (active && data?.ok) {
          setAdminName(data.admin?.name || data.admin?.email || "Admin");
          setAuthState("ready");
        }
      })
      .catch(() => { if (active) setAuthState("unavailable"); });
    return () => { active = false; };
  }, [navigate]);

  const isTeamPage = location.pathname === "/admin/team";
  const isSearchPage = location.pathname === "/admin/search";
  const isManageUserPage = location.pathname.startsWith("/admin/users/");

  const signOut = async () => {
    setSigningOut(true);
    try {
      await fetch("/api/admin/auth/logout", { method: "POST", credentials: "include" });
    } finally {
      navigate("/admin/login", { replace: true });
    }
  };

  if (authState === "checking") return <main className="bubly-admin-loading">Checking secure admin session…</main>;
  if (authState === "unavailable") return <main className="bubly-admin-loading">Admin service unavailable. Check the local backend.</main>;

  return (
    <div className="bubly-admin">
      <aside className="bubly-admin-sidebar">
        <div className="bubly-admin-brand">
          <img
            src="/assets/img/bublyuplogoheader-admin.png"
            alt="BublyUp Admin"
          />
        </div>

        <nav className="bubly-admin-nav">
          <div className="bubly-admin-nav-section">MAIN</div>

          <a href="/admin">Overview</a>
          <a href="/admin/search">Customers &amp; support</a>

          <div className="bubly-admin-nav-section">SYSTEM</div>

          <a href="/admin/team">Team &amp; Roles</a>
        </nav>
      </aside>

      <main className="bubly-admin-main">
        <header className="bubly-admin-header">
          <div>
            <span>ADMINISTRATION</span>
            <h1>BublyUp Admin{adminName ? ` · ${adminName}` : ""}</h1>
          </div>
          <button type="button" className="admin-sign-out" onClick={signOut} disabled={signingOut}>{signingOut ? "Signing out…" : "Sign out"}</button>
        </header>

        <section className="bubly-admin-content">
          {isTeamPage ? (
            <AdminTeam />
          ) : isManageUserPage ? (
            <AdminUserManage />
          ) : isSearchPage ? (
            <AdminUserSearch />
          ) : (
            <>
              <div className="bubly-admin-welcome">
                <div>
                  <span>SUPPORT WORKSPACE</span>
                  <h2>Customer support and records</h2>
                  <p>
                    Search with a support reason, open a customer record, review network and location history, update approved profile details, and document support or legal requests. Every search, archive view, and change is logged.
                  </p>
                  <a className="admin-customer-open" href="/admin/search">Find a customer</a>
                </div>
              </div>
            </>
          )}
        </section>
      </main>
    </div>
  );
}

export default Admin;
